export default __webpack_public_path__ + "static/media/center-pointe-2020.1accb9dd.svg";